import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import ToolTip from '../../../ui/ToolTip'
import Upload from '../../convertirTiendaOficial/Upload'

const ModalBanner = ({ tienda, setTienda }) => {
  const [show, setShow] = useState(false)
  const [usaBanner, setUsaBanner] = useState(false)

  useEffect(() => {
    setUsaBanner(tienda.usaBanner)
  }, [tienda])

  const handleModal = () => setShow(true)

  const cerrarModal = (path) => {
    setShow(false)
    setUsaBanner(true)
    setTienda((prev) => ({
      ...prev,
      usaBanner: path
    }))
  }

  return (
    <>
      <ToolTip
        contenido={'Este Plan no admite la utilización de un Banner'}
        flecha={true}
        duracion={0}
        esconder={tienda.usaBanner}
      >
        <Button
          data-target="logo"
          data-toggle="modal"
          variant="datos-perfil"
          onClick={() => {
            handleModal(tienda.usaBanner)
          }}
        >
          <span className="float-left">Banner</span>
          <span className="float-right">
            <i
              className={`fa ${
                tienda.bannerPath !== null || usaBanner === true
                  ? 'fa-check f-ebm-green'
                  : 'fa-times f-red'
              }`}
              aria-hidden="true"
            />
          </span>
        </Button>
      </ToolTip>

      {show && (
        <div
          className="modal fade show d-block"
          role="dialog"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
          onClick={() => setShow(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            style={{ maxWidth: '50%' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content" style={{ height: '90%' }}>
              <div className="modal-header">
                <h5 className="modal-title">
                  <b>Agregar Banner</b>
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShow(false)}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '1.5rem',
                    lineHeight: '1',
                    cursor: 'pointer'
                  }}
                  aria-label="Cerrar"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <Upload
                  esBanner={true}
                  accept={'image/*'}
                  idTiendaOficial={tienda.idTiendaOficial}
                  onCerrarModal={(path) => cerrarModal(path)}
                />
                <p className="text-center mt-3">
                  La imagen tiene que tener un tamaño aproximado de
                  <b>1728px x 250px</b> para mantener su proporción.
                </p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShow(false)}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

ModalBanner.propTypes = {
  tienda: PropTypes.shape({
    usaBanner: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    bannerPath: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idTiendaOficial: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }).isRequired,
  setTienda: PropTypes.func.isRequired
}

export default ModalBanner
